import { apiClient } from './api';
import type {
  BankTransferConfigSummary,
  BankTransferConfigDetail,
  SaveBankTransferConfigRequest,
} from '../types/bankTransferConfig';

export const getConfig = async (apartmentId: string): Promise<BankTransferConfigSummary> => {
  const response = await apiClient.get<BankTransferConfigSummary>(
    `/admin/apartments/${apartmentId}/bank-transfer-configuration`
  );
  return response.data;
};

export const revealConfig = async (apartmentId: string): Promise<BankTransferConfigDetail | null> => {
  try {
    const response = await apiClient.get<BankTransferConfigDetail>(
      `/admin/apartments/${apartmentId}/bank-transfer-configuration/reveal`
    );
    return response.data;
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    if (status === 404) return null;
    throw err;
  }
};

export const saveConfig = async (
  apartmentId: string,
  request: SaveBankTransferConfigRequest,
  idempotencyKey: string,
  version: number | null
): Promise<BankTransferConfigSummary> => {
  const response = await apiClient.put<BankTransferConfigSummary>(
    `/admin/apartments/${apartmentId}/bank-transfer-configuration`,
    request,
    {
      headers: {
        'Idempotency-Key': idempotencyKey,
        ...(version !== null ? { 'If-Match': String(version) } : {}),
      },
    }
  );
  return response.data;
};
